import type { MechKey } from './keys';

export const it: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Meccanica · 2D',
  'panel.scene': 'Scena',
  'panel.dims': 'Parametri',
  'panel.style': 'Aspetto',
  'panel.action': 'Controlli',
  'style.body': 'Corpo',
  'style.vector': 'Vettori',
  'style.ground': 'Suolo',
  'style.forces': 'Mostra forze',
  'style.trace': 'Mostra traccia',
  'style.labels': 'Etichette vettori',
  'hint.line1': 'Clicca su riproduci per iniziare · trascina i corpi per spostarli',
  'hint.line2': 'Sandbox: scegli una forma, poi clicca per posizionarla',
  'scene.incline': 'Piano inclinato',
  'scene.projectile': 'Moto del proiettile',
  'scene.pendulum': 'Pendolo',
  'scene.springMass': 'Sistema massa-molla',
  'scene.collisions': 'Collisioni',
  'scene.atwood': 'Macchina di Atwood',
  'scene.circular': 'Moto circolare',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'angolo (°)',
  'dim.friction': 'attrito',
  'dim.mass': 'massa',
  'dim.massA': 'massa A',
  'dim.massB': 'massa B',
  'dim.velocity': 'velocità',
  'dim.angleLaunch': 'angolo di lancio (°)',
  'dim.gravity': 'gravità',
  'dim.gravityX': 'gravità x',
  'dim.gravityY': 'gravità y',
  'dim.length': 'lunghezza',
  'dim.damping': 'smorzamento',
  'dim.spring': 'rigidità',
  'dim.restitution': 'restituzione',
  'dim.radius': 'raggio',
  'dim.speed': 'rapidità',
  'action.play': 'Riproduci',
  'action.pause': 'Pausa',
  'action.step': 'Passo',
  'action.reset': 'Reimposta',
  'action.speed': 'Velocità',
  'action.clear': 'Cancella',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravità',
  'forceName.normal': 'Forza normale',
  'forceName.friction': 'Attrito',
  'forceName.tension': 'Tensione',
  'forceName.spring': 'Forza elastica',
  'forceName.applied': 'Forza applicata',
  'forceName.air': "Resistenza dell'aria",
  'palette.box': 'Cubo',
  'palette.circle': 'Palla',
  'palette.ramp': 'Rampa',
  'palette.ground': 'Suolo',
  'palette.hint': 'Scegli una forma, poi clicca sul canvas per posizionarla.',
  'panel.forces': 'Forze osservate',
  'forces.empty': 'Nessuna ancora — riproduci la scena',
};
